import {environment} from "../../env";
import MenuItem from "@mui/material/MenuItem";
import React from "react";
import type {Bag} from "../../services/classes/Bag";
import type {SelectProps} from "@mui/material/Select";
import Select from "@mui/material/Select";
import {AdminPanelSettings, RemoveCircle, ShortText, VisibilityOff} from "@mui/icons-material";
import {useStores} from "../../stores";
import {Divider} from "@mui/material";

type Props = SelectProps & {
    bags: Bag[]
};
export const SelectDatasetMenu: React.FC<Props> = ({bags, ...selectProps}) => {
    const {authStore} = useStores();
    const showStaffMenu = environment.isTest || authStore.isMithraStaffGroup;
    const visible = bags.filter(b => !b.hidden);

    if (!showStaffMenu) {
        return <Select {...selectProps}>
            {visible.map(bag => <MenuItem key={bag.id} value={bag.id}>
                {bag.name}
            </MenuItem>)}
        </Select>
    } else {
        // Show all other databags as well
        const hidden = bags.filter(b => b.hidden && !b.disabled);
        const disabled = bags.filter(b => b.hidden && b.disabled);

        // Note: We cannot use fragments here
        return <Select {...selectProps}>
            {visible.map(bag => <MenuItem key={bag.id} value={bag.id}>
                <StaffMenuItem bag={bag}/>
            </MenuItem>)}
            {hidden.length > 0 && <Divider/>}
            {hidden.map(bag => <MenuItem key={bag.id} value={bag.id}>
                <StaffMenuItem bag={bag}/>
            </MenuItem>)}
            {disabled.length > 0 && <Divider/>}
            {disabled.map(bag => <MenuItem key={bag.id} value={bag.id}>
                <StaffMenuItem bag={bag}/>
            </MenuItem>)}
        </Select>
    }
}

const StaffMenuItem: React.FC<{bag: Bag}> = ({bag}) => {
    const icons = [
        bag.hidden ? <VisibilityOff key="hidden" titleAccess="Hidden"/> : null,
        bag.disabled ? <RemoveCircle key="disabled" titleAccess="Disabled"/> : null,
        bag.is_sample_of ? <ShortText key="is_sample_of" titleAccess="Sample"/> : null,
    ].filter(Boolean);
    return <>
        <AdminPanelSettings/>
        {icons}
        [{bag.id}] {bag.name}
    </>;
}
